import { Navigate } from 'react-router-dom';

import { useSelectedCompany } from '../../contexts/ClientDataContext';

export default function CompanyPage() {
  const selectedCompany = useSelectedCompany();
  const { slug } = selectedCompany;

  return <Navigate to={`/company/${slug}/tickets`} replace />;
}
